import GridPagination, { Props as ImportedProps } from './GridPagination';
import { Props as ImportedSwitcherProps } from './GridSwitcher';
import { Props as ImportedResultTextProps } from './GridResultText';

export type Props = ImportedProps;
export type SwitcherProps = ImportedSwitcherProps;
export type ResultTextProps = ImportedResultTextProps;
export default GridPagination;
